/* eslint-disable no-useless-escape */
export const embedableYoutubeVideo = url => {
  const [, , videoIdPart] =
    (!!url &&
      url.split(
        /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/,
      )) ||
    []
  const videoId = videoIdPart && videoIdPart.length === 11 ? videoIdPart : null

  return videoId && `https://www.youtube.com/embed/${videoId}`
}
